import styled from '@emotion/styled';
import { useSelector } from 'react-redux';
import { Spacings, mobile, Fonts } from '../../../../styleConstants';
import SectionTitle from '../SectionTitle';
import SectionDescription from '../SectionDescription';
import ContentContainer from '../ContentContainer';

const CenterText = styled.div`
  margin-left: auto !important;
  margin-right: auto !important;
  text-align: center;
  @media only screen and (max-width: ${mobile.maxWidth}) {
    text-align: left;
  }
`;

const StyledTitle = styled(SectionTitle)`
  width: 70%;
  font-size: 80px;
  @media only screen and (max-width: ${mobile.maxWidth}) {
    font-size: ${Fonts.H2};
    width: 100%;
  }
`;

const Wrapper = styled.section`
  width: 100vw;
  padding: 0px 115px;
  @media only screen and (max-width: ${mobile.maxWidth}) {
    padding: 0px ${Spacings.SPACING_5B};
    margin-top: 120px;
  }
`;

const StyledDescription = styled(SectionDescription)`
  width: 84%;
  font-size: 28px;
  margin-top: ${Spacings.SPACING_10B};
  @media only screen and (max-width: ${mobile.maxWidth}) {
    margin-top: ${Spacings.SPACING_4B};
    font-size: ${Fonts.LARGE};
    width: 100%;
  }
`;

const StatsWrapper = styled.div`
  display: grid;
  grid-template-columns: repeat(4, max-content);
  grid-column-gap: 93px;
  margin-top: ${Spacings.SPACING_20B};
  justify-content: center;
  @media only screen and (max-width: ${mobile.maxWidth}) {
    margin-top: ${Spacings.SPACING_10B};
    grid-template-columns: 1fr 1fr;
    grid-gap: ${Spacings.SPACING_10B};
  }
`;

const StatContainer = styled.div``;

const StatLabel = styled(SectionTitle)`
  text-align: center;
  @media only screen and (max-width: ${mobile.maxWidth}) {
    font-size: 40px;
  }
`;
const StatDescription = styled(SectionDescription)`
  text-align: center;
  @media only screen and (max-width: ${mobile.maxWidth}) {
    font-size: ${Fonts.LARGE};
  }
`;

const SummitStats = () => {
  const stats = useSelector(({ summit }) => summit.info?.stats || []);
  const staticTexts = useSelector(({ summit }) => summit.staticTexts);
  return (
    <Wrapper>
      <ContentContainer>
        <CenterText as={StyledTitle}>{staticTexts.subHeader || ''}</CenterText>
        <CenterText as={StyledDescription}>
          {staticTexts.subDesc || ''}
        </CenterText>
        <StatsWrapper>
          {stats.map((stat) => (
            <StatContainer key={stat.label}>
              <StatLabel $size="72px" $color={stat.color}>
                {stat.count}
              </StatLabel>
              <StatDescription>{stat.label}</StatDescription>
            </StatContainer>
          ))}
        </StatsWrapper>
      </ContentContainer>
    </Wrapper>
  );
};

export default SummitStats;
